export const colors = {
  bgPrimary: "#0F172A",
  bgSecondary: "#1E293B",
  semaOrange: "#FF9933",
  cream: "#FFF8F0",
  white: "#F8FAFC",
} as const;
